import { FC } from 'react'

const DetailPersonalInfo: FC = () => {
  return (
    <div className="flex h-full">
    </div>
  )
}

export default DetailPersonalInfo
